import React from 'react';

import { Typography } from 'e100-react-components';
import { Box } from 'shared/components';

import { useFavouriteBrands } from 'entities/brands';
import { useIntl } from 'react-intl';
import { useFilteredFavouriteBrands } from '../../../../hooks';
import { useStyles } from './styles';

export const EmptyFilteredItemsMessage = () => {
  const { formatMessage } = useIntl();
  const favouriteBrands = useFavouriteBrands() || [];
  const filteredFavouriteBrands = useFilteredFavouriteBrands();
  const classes = useStyles();

  if (!(!filteredFavouriteBrands.length && favouriteBrands.length)) {
    return null;
  }

  return (
    <Box
      padding={{
        left: 2.75,
        right: 2.75
      }}
    >
      <Typography
        color="secondary"
        variant="subtitle2"
        classes={{
          root: classes.title
        }}
      >
        {formatMessage({ id: 'nothingWasFound' })}
      </Typography>
    </Box>
  );
};
